(function () {
  'use strict';

  window.DIAGNOSTIC_FAQ = {
    'Vitalité & Fatigue': {
      title: 'FAQ — Vitalité & Immunité',
      products: 'Multi-Vitamines, Immunité, Énergie+, Vitamine D Végétale, Vitamine C liposomale',
      items: [
        {
          q: 'Je suis fatigué(e) dès le matin : est-ce adapté à mon profil ?',
          a: "Oui, si votre fatigue est liée à un rythme soutenu, une période chargée ou des apports nutritionnels insuffisants. Une formule orientée vitalité peut accompagner les besoins du quotidien. Si la fatigue est intense, persistante ou inexpliquée, un avis médical est préférable avant toute supplémentation."
        },
        {
          q: 'Je tombe souvent "à plat" en fin de journée : que peut m\'apporter cette cure ?',
          a: "Elle peut accompagner les périodes où l'organisme est davantage sollicité : travail intense, sommeil moins réparateur, stress, changement de saison ou alimentation déséquilibrée. L'objectif est d'apporter un soutien nutritionnel cohérent, non de stimuler artificiellement."
        },
        {
          q: 'Pourquoi le diagnostic peut-il recommander de la Vitamine D ?',
          a: "Une exposition solaire limitée, le travail en intérieur ou certaines périodes de l'année peuvent rendre les apports en vitamine D plus difficiles à couvrir par l'alimentation seule. Une complémentation peut être pertinente dans le respect des doses journalières recommandées."
        },
        {
          q: 'Quelle différence entre fatigue nerveuse et fatigue physique ?',
          a: "La fatigue nerveuse est souvent liée au stress, à la charge mentale ou à un sommeil peu récupérateur. La fatigue physique se traduit plutôt par un manque de tonus ou une sensation d'épuisement. Selon vos réponses, le diagnostic peut orienter vers une formule plus globale : magnésium, multivitamines ou énergie."
        },
        {
          q: 'Puis-je prendre cette routine si mon alimentation est déjà correcte ?',
          a: "Oui, mais l'intérêt dépend de votre besoin réel. Même avec une alimentation équilibrée, certaines périodes peuvent augmenter les besoins : fatigue passagère, saison hivernale, stress, activité intense. Le complément reste un soutien ponctuel, pas une obligation."
        },
        {
          q: 'Quand dois-je consulter plutôt que prendre un complément ?',
          a: "Si la fatigue est brutale, persistante, associée à une perte de poids, des douleurs, un essoufflement ou des vertiges, consultez un professionnel de santé. Le diagnostic Theralica aide à orienter une routine bien-être, mais ne remplace pas un avis médical."
        }
      ]
    },

    'Stress & Sommeil': {
      title: 'FAQ — Stress & Sommeil',
      products: 'Stress Nuit Sommeil, Stress Jour',
      items: [
        {
          q: "J'ai surtout le cerveau qui tourne le soir : est-ce le bon résultat ?",
          a: "Oui, si votre difficulté principale est de décrocher après la journée ou de préparer un coucher plus serein. Une routine du soir peut aider à installer un rituel plus calme, en complément de bonnes habitudes : limiter les écrans, alléger le repas du soir, conserver des horaires réguliers."
        },
        {
          q: "Je suis tendu(e) en journée mais je dors plutôt bien : que faire ?",
          a: "Dans ce cas, le besoin est davantage orienté vers le soutien de l'équilibre nerveux en journée. L'objectif est d'accompagner la détente pendant les périodes de rythme soutenu, sans forcément agir sur la routine du coucher."
        },
        {
          q: "Ce type de complément peut-il remplacer une bonne hygiène de sommeil ?",
          a: "Non. Le complément fonctionne mieux lorsqu'il s'intègre dans une routine cohérente : horaires réguliers, environnement calme, réduction des excitants, exposition à la lumière le matin, limitation des écrans le soir. Il accompagne la routine, il ne la remplace pas."
        },
        {
          q: "Je me réveille fatigué(e) : est-ce forcément un problème de sommeil ?",
          a: "Pas toujours. Un réveil difficile peut être lié au stress, à une dette de sommeil, à une alimentation déséquilibrée ou à un rythme irrégulier. Si les réveils non réparateurs persistent malgré une bonne hygiène de vie, consultez un professionnel de santé."
        },
        {
          q: "Puis-je utiliser une routine stress en période ponctuelle seulement ?",
          a: "Oui, ce type de routine peut être pertinent lors de périodes ponctuelles : surcharge de travail, examens, changements de rythme, tensions passagères. L'important est de respecter les conseils d'utilisation et de ne pas dépasser la dose journalière recommandée."
        },
        {
          q: "Peut-on associer la routine stress et la routine sommeil ?",
          a: "Cela dépend de votre profil. Si vous ressentez à la fois des tensions en journée et des difficultés le soir, les deux formules peuvent s'envisager selon les recommandations. Consultez votre pharmacien si vous avez un doute, notamment en cas de traitement médicamenteux en cours."
        }
      ]
    },

    'Minceur & Silhouette': {
      title: 'FAQ — Minceur & Métabolisme',
      products: 'Minceur Contrôle, Chrome CR Cannelle, Minceur Ventre Plat, Minceur Cellulite',
      items: [
        {
          q: "J'ai surtout des envies sucrées : pourquoi le diagnostic oriente-t-il vers Chrome CR Cannelle ?",
          a: "Lorsque l'objectif concerne l'équilibre alimentaire et les envies de sucre, une formule ciblée autour du chrome peut être pertinente dans une routine métabolique. Elle doit rester associée à des repas structurés, une hydratation suffisante et une réduction progressive des grignotages."
        },
        {
          q: "J'ai le ventre gonflé : est-ce plutôt minceur ou digestion ?",
          a: "Cela dépend de la cause ressentie. Si le besoin concerne surtout la sensation de ventre plat ou le confort après les repas, le diagnostic peut orienter vers une solution ventre plat ou digestion. Si le besoin est globalement silhouette, la recommandation peut différer."
        },
        {
          q: "Je veux cibler la cellulite : que faut-il associer à la cure ?",
          a: "Pour une routine cellulite cohérente, associez la cure à l'hydratation, au mouvement, à une alimentation équilibrée et à des massages réguliers des zones concernées. Le complément accompagne la démarche, mais l'effet dépend fortement de la régularité globale."
        },
        {
          q: "Si je ne fais pas de sport, est-ce utile de prendre une cure minceur ?",
          a: "Une cure minceur peut accompagner une routine plus légère, mais les résultats seront plus cohérents si elle est associée à une activité physique même modérée : marche, escaliers, mobilité quotidienne. L'objectif est de créer une dynamique durable, pas une solution isolée."
        },
        {
          q: "Pourquoi le diagnostic ne promet-il pas une perte de poids rapide ?",
          a: "Parce qu'un complément alimentaire ne peut pas être présenté comme une solution miracle, conformément à la réglementation en vigueur (CE 1924/2006). Une démarche minceur sérieuse repose sur la régularité : alimentation, sommeil, hydratation, activité physique et gestion du stress."
        },
        {
          q: "Ces produits conviennent-ils en cas de diabète ou de traitement médicamenteux ?",
          a: "En cas de pathologie, de traitement médicamenteux en cours — notamment pour la glycémie — ou de grossesse, consultez impérativement votre médecin ou pharmacien avant de commencer toute supplémentation."
        }
      ]
    },

    'Peau & Cheveux': {
      title: 'FAQ — Nutricosmétiques : Cheveux, Peau & Ongles',
      products: 'Cheveux & Ongles Croissance, Cheveux Anti-chute, Acide Hyaluronique RE-PULP, Antioxydant, Peau Nette Perfecteur, Peau Sèche Nutrition, Solaire Hydratant Anti-âge',
      items: [
        {
          q: "Mes cheveux cassent mais je ne les perds pas forcément : est-ce le même besoin ?",
          a: "Non. La casse concerne la qualité de la fibre et la fragilité. La chute concerne la densité perçue ou la perte réelle de cheveux. Le diagnostic peut orienter vers une formule Cheveux & Ongles Croissance ou vers une formule Anti-chute selon vos réponses spécifiques."
        },
        {
          q: "J'ai la peau sèche malgré mes crèmes : pourquoi agir aussi de l'intérieur ?",
          a: "Une crème hydratante agit en surface. Une routine nutricosmétique peut accompagner les apports internes utiles à la qualité de la peau. En cas de peau sèche, l'approche la plus cohérente combine hydratation, soins externes, apports nutritionnels et régularité dans la durée."
        },
        {
          q: "Mon teint est terne : hydratation, antioxydants ou peau nette ?",
          a: "Cela dépend du contexte. Un teint terne avec tiraillements oriente vers l'hydratation interne. Un teint fatigué exposé au stress, au soleil ou à la pollution peut orienter vers les antioxydants. Un teint irrégulier avec imperfections peut orienter vers une formule Peau Nette."
        },
        {
          q: "Combien de temps faut-il pour voir une amélioration cheveux ou peau ?",
          a: "Les cheveux, les ongles et la peau évoluent progressivement. La régularité est essentielle. Les premiers résultats s'observent généralement après 4 à 8 semaines de cure régulière, en association avec des soins adaptés. Il ne faut pas attendre de changement immédiat."
        },
        {
          q: "Peut-on utiliser une routine nutricosmétique en prévention ?",
          a: "Oui, si le besoin est cohérent : changement de saison, période de stress, cheveux fragilisés, peau déshydratée, exposition solaire ou perte d'éclat. L'objectif peut être de soutenir la qualité de la peau et des cheveux avant que le déséquilibre ne s'installe."
        },
        {
          q: "Quand une chute de cheveux doit-elle conduire à consulter un médecin ?",
          a: "Si la chute est brutale, importante, localisée, accompagnée de démangeaisons, de plaques, de fatigue marquée ou si elle dure plusieurs mois, consultez un professionnel de santé. Un complément accompagne une routine, mais ne remplace pas un diagnostic médical."
        }
      ]
    },

    'Digestion & Transit': {
      title: 'FAQ — Digestion & Transit',
      products: 'Probiotiques 10 milliards, Detox, Draineur universel, Transit',
      items: [
        {
          q: "J'ai souvent le ventre gonflé : est-ce forcément lié à l'alimentation ?",
          a: "Pas toujours. Le ventre gonflé peut être favorisé par les repas trop rapides, le stress, le manque d'hydratation, certains aliments ou un transit ralenti. Le diagnostic aide à orienter vers une routine de confort digestif, mais ne remplace pas un avis médical en cas de symptômes persistants."
        },
        {
          q: "Pourquoi le diagnostic peut-il recommander des probiotiques ?",
          a: "Les probiotiques peuvent être proposés lorsque le besoin concerne l'équilibre du microbiote intestinal, le confort digestif ou des changements de rythme alimentaire. Ils s'intègrent dans une routine régulière, avec une alimentation variée et riche en fibres."
        },
        {
          q: "Si mon transit est lent, faut-il une formule transit plutôt qu'une formule digestion globale ?",
          a: "Oui, si le besoin principal concerne la régularité du transit. Une formule transit est plus ciblée sur cette problématique, tandis qu'une formule digestion globale accompagne plutôt le confort autour des repas et la sensation de légèreté."
        },
        {
          q: "À quoi sert une routine détox ou drainage après une période d'excès ?",
          a: "Elle peut accompagner une reprise de routine plus légère après des repas riches ou une période festive. L'objectif est d'aider à retrouver de bonnes habitudes : hydratation, repas plus simples, fibres, activité douce. Ce n'est pas une solution médicale."
        },
        {
          q: "Que faire si les inconforts digestifs reviennent souvent ?",
          a: "Observez les déclencheurs : repas copieux, stress, manque de fibres, hydratation insuffisante, rythme irrégulier. Si les symptômes sont fréquents, douloureux, associés à une perte de poids, du sang dans les selles, de la fièvre ou une gêne importante, consultez rapidement un médecin."
        },
        {
          q: "Les probiotiques conviennent-ils en cas de traitement antibiotique ?",
          a: "Dans ce contexte spécifique, il est conseillé de demander l'avis de votre médecin ou pharmacien. Un professionnel de santé pourra vous orienter sur le moment et les modalités les plus adaptés à votre situation."
        }
      ]
    },

    'Circulation & Articulations': {
      title: 'FAQ — Vitamines & Minéraux ciblés',
      products: 'Zinc Immunité Peau et Cheveux, Chrome CR Cannelle, Probiotiques 3 milliards, Vitamine D Végétale, Oméga 3 Microalgue, Vitamine C liposomale',
      items: [
        {
          q: "Comment savoir si j'ai besoin d'un actif ciblé ou d'une formule complète ?",
          a: "Si votre besoin est large — fatigue, rythme intense, alimentation irrégulière — une formule complète peut être plus adaptée. Si votre besoin est précis — magnésium, vitamine D, fer, zinc, oméga-3 — un actif ciblé peut être plus pertinent et suffisant."
        },
        {
          q: "Pourquoi le magnésium est-il souvent associé à la fatigue nerveuse ?",
          a: "Le magnésium est souvent choisi lorsque le besoin concerne la tension nerveuse, le rythme soutenu ou la fatigue liée au stress. Il s'intègre dans une routine globale incluant sommeil, récupération, hydratation et réduction des excitants comme la caféine."
        },
        {
          q: "Pourquoi recommander des Oméga-3 Microalgue plutôt que du poisson ?",
          a: "Si vos apports en poissons gras sont faibles, ou si vous suivez un régime végétarien ou végane, une formule d'oméga-3 issue de microalgues peut compléter la routine nutritionnelle de façon cohérente et durable, sans nécessiter de sources animales."
        },
        {
          q: "Le fer doit-il être pris systématiquement en cas de fatigue ?",
          a: "Non. La fatigue ne signifie pas automatiquement un besoin en fer. Une supplémentation en fer sans carence confirmée peut être contre-indiquée. En cas de fatigue persistante ou de suspicion de carence, il est préférable de demander un avis médical avant toute prise."
        },
        {
          q: "Zinc, vitamine C, vitamine D : pourquoi sont-ils souvent liés à l'immunité ?",
          a: "Certains micronutriments comme la vitamine C, la vitamine D ou le zinc contribuent au fonctionnement normal du système immunitaire, conformément aux allégations autorisées par le règlement (CE) n° 1924/2006, dans le respect des dosages réglementaires."
        },
        {
          q: "Peut-on faire une cure ciblée sans analyse sanguine ?",
          a: "Pour certains actifs courants, une cure ponctuelle peut être envisagée en respectant les recommandations. Pour le fer, la vitamine D à dose élevée, en cas de grossesse, d'allaitement ou de traitement médicamenteux en cours, un avis professionnel est indispensable."
        }
      ]
    }
  };

})();
